import { render, staticRenderFns } from "./PrintInvoices.yaml?vue&type=template&id=d459b648&component"
import script from "./PrintInvoices.yaml?vue&type=script&lang=ts&component"
export * from "./PrintInvoices.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports